import type { Domain } from "../content/domains";

interface DomainChipProps {
  domain: Domain;
}

export function DomainChip({ domain }: DomainChipProps) {
  return (
    <div className="domain-chip">
      <span className="domain-chip__name">{domain.label}</span>
      <span className="domain-chip__tag mono">{domain.tag}</span>
    </div>
  );
}
